<text-field-pds3>
    <input class="wk-data-table__searchbar-input" type="text" placeholder="{{ 'DataTable.search' | wkTranslate }}" [formControl]="searchControl" />
    <icon-pds3 name="wk-icon-search" />
</text-field-pds3>
